module.exports = __webpack_public_path__ + "static/IMG_20200505_092414-5f793e7f384d2d4b00177176a62727b8.webp";